export default __webpack_public_path__ + "static/media/save-24px.997f2449.svg";